module.exports = __webpack_public_path__ + "img/asus-camera-360.abae2e77.jpg";